import { jsx as _jsx } from "react/jsx-runtime";
import { FileBlank } from "./FileBlank";
import { FileGZip } from "./FileGZip";
import { FileJson } from "./FileJson";
import { FileTxt } from "./FileTxt";
export const FileIcon = ({ file, size = 16, className = "text-gray-50", }) => {
    const f = file.toLowerCase();
    if (f.endsWith(".json")) {
        return _jsx(FileJson, { size: size, className: className });
    }
    else if (f.endsWith(".gz") || f.endsWith(".tgz")) {
        return _jsx(FileGZip, { size: size, className: className });
    }
    else if (f.endsWith(".txt") || f.endsWith(".log")) {
        return _jsx(FileTxt, { size: size, className: className });
    }
    else {
        return _jsx(FileBlank, { size: size, className: className });
    }
};
